import { styled } from '@mui/system'

export const Cell = styled('div')`
    min-height: 60px;
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: default;
`

export const NameCell = styled(Cell)`
    gap: 8px;

    .table-cell-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 230px;
    }
`

export const ActionsCell = styled(Cell)`
    justify-content: flex-end;
`

export const ActionsActivator = styled('div')`
    display: flex;
    align-items: center;
    padding: 10px;
    cursor: pointer;
`
